import { memo, useId } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-netflix-color-large.tsx
/**
* icon.24.logo.netflix.color.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2MyMDAwMCIgZD0iTTEwLjkwNSAzSDcuNDZ2MThjMS4xMy0uMjY4IDIuMzEtLjQwMiAzLjQ0NS0uNDUyeiIvPjxwYXRoIGZpbGw9InVybCgjYSkiIGQ9Ik0xMC45MDUgM0g3LjQ2djEzLjc3M2MxLjEzLS4yNjggMi4zMS0uNDAyIDMuNDQ1LS40NTJ6Ii8+PHBhdGggZmlsbD0iI2MyMDAwMCIgZD0iTTE3LjMyIDIxVjNoLTMuNDQ1djE3LjU4NGMyLjAxMi4xMjggMy40NDUuNDE2IDMuNDQ1LjQxNiIvPjxwYXRoIGZpbGw9InVybCgjYikiIGQ9Ik0xNy4zMiAyMC45OTdWOS4wNWgtMy40NDV2MTEuNTNjMi4wMTIuMTI4IDMuNDQ1LjQxNiAzLjQ0NS40MTYiLz48cGF0aCBmaWxsPSIjZTUwOTE0IiBkPSJNMTcuMzIgMjEgMTAuOTA1IDNINy40Nmw2LjI2MyAxNy41NzVjMi4wOTEuMTIyIDMuNTk3LjQyNSAzLjU5Ny40MjUiLz48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSI2Ljg0NSIgeDI9IjkuNDA5IiB5MT0iMTEuNDI0IiB5Mj0iOS40ODkiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBzdG9wLWNvbG9yPSIjQzIwMDAwIiBzdG9wLW9wYWNpdHk9IjAiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM5RDAwMDAiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCBpZD0iYiIgeDE9IjE3LjgyIiB4Mj0iMTUuNDk4IiB5MT0iMTQuMDk4IiB5Mj0iMTUuMDY2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agc3RvcC1jb2xvcj0iI0MyMDAwMCIgc3RvcC1vcGFjaXR5PSIwIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjOUQwMDAwIi8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26838-12477
*/
const Icon24LogoNetflixColorLarge = memo(function Icon24LogoNetflixColorLarge(props) {
	const id = useId();
	const ida = `${id}0`;
	const idb = `${id}1`;
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: [
			/* @__PURE__ */ jsx("path", {
				fill: "#c20000",
				d: "M10.905 3H7.46v18c1.13-.268 2.31-.402 3.445-.452z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${ida})`,
				d: "M10.905 3H7.46v13.773c1.13-.268 2.31-.402 3.445-.452z"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "#c20000",
				d: "M17.32 21V3h-3.445v17.584c2.012.128 3.445.416 3.445.416"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${idb})`,
				d: "M17.32 20.997V9.05h-3.445v11.53c2.012.128 3.445.416 3.445.416"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "#e50914",
				d: "M17.32 21 10.905 3H7.46l6.263 17.575c2.091.122 3.597.425 3.597.425"
			}),
			/* @__PURE__ */ jsxs("defs", { children: [/* @__PURE__ */ jsxs("linearGradient", {
				id: ida,
				x1: "6.845",
				x2: "9.409",
				y1: "11.424",
				y2: "9.489",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", {
					stopColor: "#C20000",
					stopOpacity: "0"
				}), /* @__PURE__ */ jsx("stop", {
					offset: "1",
					stopColor: "#9D0000"
				})]
			}), /* @__PURE__ */ jsxs("linearGradient", {
				id: idb,
				x1: "17.82",
				x2: "15.498",
				y1: "14.098",
				y2: "15.066",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", {
					stopColor: "#C20000",
					stopOpacity: "0"
				}), /* @__PURE__ */ jsx("stop", {
					offset: "1",
					stopColor: "#9D0000"
				})]
			})] })
		]
	});
});
//#endregion
export { Icon24LogoNetflixColorLarge };

//# sourceMappingURL=icon-24-logo-netflix-color-large.js.map